import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SoloNumerosDirective } from '../main/backoffice/shared/utils/directives/soloNumeros.directive';
import { MaterialModule } from './modules/material/material.module';

@NgModule({
  declarations: [SoloNumerosDirective],
  imports: [ReactiveFormsModule, FormsModule, MaterialModule, CommonModule],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    CommonModule,
    SoloNumerosDirective,
  ],
})
export class SharedModule {}
